// eslint-disable-next-line import/prefer-default-export
export const ApplicationParams = {
  ubicacioRequeridaPerFitxar: process.env.REACT_APP_PERMETRE_FITXAR_SENSE_COORDENADES
    ? process.env.REACT_APP_PERMETRE_FITXAR_SENSE_COORDENADES === 'false'
    : false,
  radiPrecisioFitxada: process.env.REACT_APP_MINIM_RADI_PRECISIO_FITXADA
    ? parseInt(process.env.REACT_APP_MINIM_RADI_PRECISIO_FITXADA, 10)
    : 100,
  baseAPIURL: `${process.env.REACT_APP_BACKEND_HOST}/${process.env.REACT_APP_BACKEND_APP_NAME}/api`,
  contextRoute: process.env.REACT_APP_CONTEXT_PATH || '/',
  client: {
    logo: process.env.REACT_APP_CLIENT_LOGO,
    name: process.env.REACT_APP_CLIENT_NAME,
    url: process.env.PUBLIC_URL,
  },
}
